var map = {
	"./gauge-high-solid.svg": "d554",
	"./heatmap.svg": "c533",
	"./histogramme.svg": "8690",
	"./numbers-chart.svg": "e681",
	"./pie-chart.svg": "0ffc",
	"./radar.svg": "bef3",
	"./scatters.svg": "05d2",
	"./tableau-complexe.svg": "49bf",
	"./tableau-simple.svg": "9c51",
	"./tableau.svg": "eb20",
	"./text.svg": "c4b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";